import React from 'react';
import { Skeleton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  barChart: {
    minHeight: 140,
    padding: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  donut: {
    width: 130,
    height: 130,
    borderRadius: '50%',
  },
  progressBar: {
    height: 10,
    borderRadius: 999,
  },
  card: {
    borderRadius: 4,
    padding: 12,
  },
  pipelineDonut: {
    width: 140,
    height: 140,
    borderRadius: '50%',
  },
  alertBadge: {
    width: 42,
    height: 26,
    borderRadius: 5,
  },
}));

export const BarChartSkeleton = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.barChart} data-testid="skeleton-bar-chart">
      <Skeleton variant="text" width={60} height={14} />
      <Skeleton variant="rectangular" width="100%" height={80} sx={{ borderRadius: 1 }} />
      <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
        <Skeleton variant="text" width={40} height={20} />
        <Skeleton variant="text" width={40} height={20} />
      </div>
    </div>
  );
};

export const DonutSkeleton = () => {
  const { classes } = useStyles();
  return (
    <div style={{ padding: 12, display: 'flex', alignItems: 'center', gap: 16 }} data-testid="skeleton-donut">
      <Skeleton className={classes.donut} variant="circular" />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Skeleton variant="text" width={80} height={12} />
        <Skeleton variant="text" width={60} height={12} />
        <Skeleton variant="text" width={70} height={12} />
      </div>
    </div>
  );
};

export const ProgressBarsSkeleton = () => {
  const { classes } = useStyles();
  return (
    <div style={{ padding: 12, display: 'flex', flexDirection: 'column', gap: 16 }} data-testid="skeleton-progress">
      {[1, 2, 3].map((i) => (
        <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Skeleton variant="text" width={120} height={12} />
          <Skeleton className={classes.progressBar} variant="rectangular" />
        </div>
      ))}
    </div>
  );
};

export const CriticalTasksSkeleton = () => (
  <div style={{ padding: 12 }} data-testid="skeleton-critical-tasks">
    <Skeleton variant="text" width={120} height={18} sx={{ mb: 2 }} />
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
      {[1, 2, 3, 4].map((i) => (
        <Skeleton key={i} variant="rectangular" height={70} sx={{ borderRadius: 1 }} />
      ))}
    </div>
  </div>
);

export const MyCandidatesSkeleton = () => (
  <div style={{ padding: 12 }} data-testid="skeleton-candidates">
    <Skeleton variant="text" width={100} height={18} sx={{ mb: 2 }} />
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8 }}>
      {[1, 2, 3, 4, 5, 6, 7].map((i) => (
        <Skeleton key={i} variant="rectangular" height={60} sx={{ borderRadius: 1 }} />
      ))}
    </div>
  </div>
);

export const PipelineAlertsSkeleton = () => {
  const { classes } = useStyles();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }} data-testid="skeleton-pipeline-alerts">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Skeleton className={classes.alertBadge} variant="rectangular" />
          <Skeleton variant="text" width={100} height={14} />
        </div>
      ))}
    </div>
  );
};

export const PipelineSkeleton = () => {
  const { classes } = useStyles();
  return (
    <div style={{ padding: 16 }} data-testid="skeleton-pipeline">
      <Skeleton variant="text" width={100} height={18} sx={{ mb: 2 }} />
      <div style={{ display: 'flex', alignItems: 'center', gap: 24, flexWrap: 'wrap' }}>
        <Skeleton className={classes.pipelineDonut} variant="circular" />
        <div style={{ flex: 1, display: 'flex', gap: 16 }}>
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} variant="circular" width={54} height={54} />
          ))}
        </div>
        <PipelineAlertsSkeleton />
      </div>
    </div>
  );
};
